import React from 'react';
import { Sponsor } from './../../elements/SponsorsElements';

const SponsorsDetail = () => (
    <Sponsor>
        <div className="container">
            <div className="sponsors">
                <div className="sponsor">
                    <img src="glamsquad.png" alt="Glam Squad Academy" />
                    <h3>Mbalenhle <span className="effect">Makhaya</span></h3>
                    <h4>Makeup Artist and Business Owner</h4>
                    <p>
                        Mbalenhle Makhaya is a professional
                        makeup artist, founder of Glam Squad
                        Academy and Bespoke the Beauty Bar,
                        She been in the makeup industry for
                        4years now, she has done editorial shoots
                        for True Love Magazine, Destiny
                        Magazine and The Throne Magazine.
                    </p>
                </div>
                <div className="sponsor">
                    <img src="inquisitive.png" alt="Inquisitive" />
                    <h3>Kgotso <span className="effect">Seema</span></h3>
                    <h4>Clothing Brand Owner</h4>
                    <p>
                        Kgotso is our official clothing sponser,
                        who sponsors Za Power House with
                        branded clothing items.
                    </p>
                </div>
                <div className="sponsor">
                    <img src="tpcreate.png" alt="TP Create" />
                    <h3>Thapelo <span className="effect">Mofokeng</span></h3>
                    <h4>Digital Creator</h4>
                    <p>
                        Thapelo is our sponsor for all our digital
                        content, all our logos and posters are
                        done by him.
                    </p>
                </div>
            </div>
        </div>
    </Sponsor>
)

export default SponsorsDetail;